module.exports = __webpack_public_path__ + "static/media/sf-trial-3-correct.a2399760.mp3";